import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';

export const SuspenseFallback = () => {
  return (
    <Container
      maxWidth="sm"
      sx={{
        height: 'calc(100vh - 20px)',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box>
        <CircularProgress />
      </Box>
    </Container>
  );
};
